import axios from 'axios';
import config from '@/utils/config';

const instance = axios.create({
  baseURL: config.get('formServiceApi'),
});

export type TSendFeedback = {
  last_name: string;
  first_name: string;
  email: string;
  phone: string;
  city: string;
  model?: string;
  vin?: string;
  dealer?: number;
  subject: string;
  confirm_personal_data_processing_policy: boolean;
};

export function sendFeedback(data: TSendFeedback) {
  return instance.post(`/feedback`, { ...data });
}

export type TSendTestDrive = {
  phone: string;
  city: string;
  dealer: string;
  model: string;
  confirm_personal_data_processing_policy: boolean;
};

export function sendTestDrive(data: TSendTestDrive) {
  return instance.post(`/test-drive`, { ...data });
}

export type TSendTradeIn = {
  last_name: string;
  first_name: string;
  email: string;
  phone: string;
  city: string;
  dealer: string;
  model: string;
  confirm_personal_data_processing_policy: boolean;
};

export function sendTradeIn(data: TSendTradeIn) {
  return instance.post(`/trade-in`, { ...data });
}

export type TSendCallback = {
  phone: string;
  city: string;
  dealer: string;
  confirm_personal_data_processing_policy: boolean;
};

export function sendCallback(data: TSendCallback) {
  return instance.post(`/callback`, { ...data });
}

export type TSendCredit = {
  last_name: string;
  first_name: string;
  email: string;
  phone: string;
  city: string;
  dealer: number;
  confirm_personal_data_processing_policy: boolean;
  credit_data: {
    title: string;
    bank: string;
    rate: string;
    payment: string;
    down_payment: number;
    number_of_periods: number;
    residual_payment?: number;
  };
};

export function sendCredit(data: TSendCredit) {
  return instance.post(`/credit`, { ...data });
}

export type TSendBooking = {
  first_name: string;
  last_name: string;
  phone: string;
  email: string;
  sku: string;
  vehicle_id: string;
  env_id: string;
  space_id: string;
  confirm_personal_data_processing_policy: boolean;
  mode: string;
  city?: string;
  notes?: string;
  promocode?: string;
  vehicle?: {
    id: string
    collection_id: string
  }
};

export function sendBooking(data: TSendBooking) {
  return instance.post(`/booking`, { ...data });
}

export type TSendRequestOnline = {
  company_name: string;
  first_name: string;
  email: string;
  phone: string;
  city: string;
  notes?: string;
  confirm_personal_data_processing_policy: boolean;
};

export function sendRequestOnline(data: TSendRequestOnline) {
  return instance.post(`/request-online`, { ...data });
}

export type TSendRequestOffer = {
  company_name: string;
  first_name: string;
  email: string;
  phone: string;
  city: string;
  notes?: string;
  confirm_personal_data_processing_policy: boolean;
};

export function sendRequestOffer(data: TSendRequestOffer) {
  return instance.post(`/request-offer`, { ...data });
}

export type TSendPreOrder = {
  first_name: string;
  last_name: string;
  patronymic: string;
  phone: string;
  email: string;
  region: string;
  vin: string;
  sku: string;
  amount: number;
  confirm_personal_data_processing_policy: boolean;
};

export function sendPreOrder(data: TSendPreOrder) {
  return instance.post(`/booking`, { ...data });
}

export type TSendRequestPrice = {
  sku: string;
  phone: string;
  confirm_personal_data_processing_policy: boolean;
};

export function sendRequestPrice(data: TSendRequestPrice) {
  return instance.post('/online-price', { ...data });
}

export type TSendLeasing = {
  model: string;
  grade: string;
  color: string;
  number_of_periods: string;
  down_payment: string;
  schedule: string;
  city: string;
  dealer: string;
  first_name: string;
  phone: string;
  email: string;
  legal_entity: string;
  inn: string;
  time: string;
  confirm_personal_data_processing_policy: boolean;
  confirm_consent_marketing_materials: boolean;
};

export function sendLeasing(data: TSendTradeIn) {
  return instance.post(`/leasing`, { ...data });
}

export default instance;
